import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyCommissions } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./TradingCommissionPage.css";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

const TradingCommissionPage = () => {
  const [commissions] = useState(dummyCommissions);
  const [search, setSearch] = useState("");
  const [viewOrder, setViewOrder] = useState(null);

  const filtered = commissions.filter(
    (c) =>
      c._id?.toLowerCase().includes(search.toLowerCase()) ||
      c.fromOrder?.toLowerCase().includes(search.toLowerCase()) ||
      c.short_name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Trading Commission</span>
          </p>
          <h1 className="dashboard-hero__title">Trading Commission</h1>
          <p className="dashboard-hero__subtitle">
            Configure trading commission tiers and view commission history
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-chart-pie" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="commission-section">
          <div className="commission-section__header">
            <div className="commission-section__title-wrap">
              <span className="commission-section__icon">
                <i className="fas fa-percentage" />
              </span>
              <h2 className="commission-section__title">Commission History</h2>
            </div>
            <div className="commission-section__stats">
              <span className="commission-stat">
                <strong>{commissions.length}</strong> Records
              </span>
            </div>
          </div>
          <div className="commission-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by ID, order ID or currency..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="commission-search-input"
            />
          </div>
          <div className="commission-table-wrap">
            <table className="commission-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Created</th>
                  <th>Currency</th>
                  <th>From Order</th>
                  <th>Amount</th>
                  <th>%</th>
                  <th>Fee</th>
                  <th>Fee Type</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((row) => (
                  <tr key={row._id}>
                    <td><span className="commission-mono">{row._id}</span></td>
                    <td>{formatDate(row.createdAt)}</td>
                    <td><strong>{row.short_name}</strong></td>
                    <td><span className="commission-mono">{row.fromOrder}</span></td>
                    <td>{typeof row.amount === "number" ? row.amount.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.amount}</td>
                    <td>{typeof row.percentage === "number" ? row.percentage + "%" : row.percentage}</td>
                    <td>{typeof row.fee === "number" ? row.fee.toLocaleString("en-IN", { minimumFractionDigits: 4 }) : row.fee}</td>
                    <td>
                      <span className={`commission-fee-type commission-fee-type--${(row.fee_type || "").toLowerCase()}`}>
                        {row.fee_type}
                      </span>
                    </td>
                    <td>
                      {row.order_details && (
                        <button
                          type="button"
                          className="commission-btn commission-btn--view"
                          onClick={() => setViewOrder(row)}
                        >
                          <i className="fas fa-eye" /> View Order
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filtered.length === 0 && (
            <p className="commission-empty">No commission records match your search.</p>
          )}
        </section>
      </div>

      {/* Order details modal */}
      {viewOrder?.order_details && (
        <div className="commission-modal-overlay" onClick={() => setViewOrder(null)}>
          <div className="commission-modal" onClick={(e) => e.stopPropagation()}>
            <div className="commission-modal__header">
              <h3>Order Details — {viewOrder.fromOrder}</h3>
              <button type="button" className="commission-modal__close" onClick={() => setViewOrder(null)} aria-label="Close">
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="commission-modal__body">
              <dl className="commission-dl">
                <div><dt>Order ID</dt><dd className="commission-mono">{viewOrder.order_details.orderId}</dd></div>
                <div><dt>Ask Currency</dt><dd>{viewOrder.order_details.ask_currency}</dd></div>
                <div><dt>Pay Currency</dt><dd>{viewOrder.order_details.pay_currency}</dd></div>
                <div><dt>Side</dt><dd><span className={`commission-side commission-side--${(viewOrder.order_details.side || "").toLowerCase()}`}>{viewOrder.order_details.side}</span></dd></div>
                <div><dt>Order Type</dt><dd>{viewOrder.order_details.order_type}</dd></div>
                <div><dt>Price</dt><dd>{typeof viewOrder.order_details.price === "number" ? viewOrder.order_details.price.toLocaleString("en-IN", { minimumFractionDigits: 2 }) : viewOrder.order_details.price}</dd></div>
                <div><dt>Quantity</dt><dd>{typeof viewOrder.order_details.quantity === "number" ? viewOrder.order_details.quantity.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : viewOrder.order_details.quantity}</dd></div>
                <div><dt>Status</dt><dd><span className="commission-status">{viewOrder.order_details.status}</span></dd></div>
              </dl>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default TradingCommissionPage;
